import { Action } from '@ngrx/store';


import { SingleResponseModel } from '../../../../common/models/single-response.model';
import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';

import { SummaryPrivateFinancingModel } from '../../models/summary-private-financing.model';


export enum PrivateFinancingActionTypes {
  LoadPrivateFinancings = '[PrivateFinancing] Load PrivateFinancings',
  LoadPrivateFinancingsSuccess = '[PrivateFinancing] Load PrivateFinancings Success',
  LoadPrivateFinancingsFailure = '[PrivateFinancing] Load PrivateFinancings Failure',

  LoadPrivateFinancing = '[PrivateFinancing] Load PrivateFinancing',
  LoadPrivateFinancingSuccess = '[PrivateFinancing] Load PrivateFinancing Success',
  LoadPrivateFinancingFailure = '[PrivateFinancing] Load PrivateFinancing Failure',

  CreatePrivateFinancing = '[PrivateFinancing] Create PrivateFinancing',
  CreatePrivateFinancingSuccess = '[PrivateFinancing] Create PrivateFinancing Success',
  CreatePrivateFinancingFailure = '[PrivateFinancing] Create PrivateFinancing Failure',

  UpdatePrivateFinancing = '[PrivateFinancing] Update PrivateFinancing',
  UpdatePrivateFinancingSuccess = '[PrivateFinancing] Update PrivateFinancing Success',
  UpdatePrivateFinancingFailure = '[PrivateFinancing] Update PrivateFinancing Failure',

  DeletePrivateFinancing = '[PrivateFinancing] Delete PrivateFinancing',
  DeletePrivateFinancingSuccess = '[PrivateFinancing] Delete PrivateFinancing Success',
  DeletePrivateFinancingFailure = '[PrivateFinancing] Delete PrivateFinancing Failure',
}

/** Load all */

export class LoadPrivateFinancings implements Action {
  readonly type = PrivateFinancingActionTypes.LoadPrivateFinancings;
  constructor(public payload: {filter: any}) {}
}

export class LoadPrivateFinancingsSuccess implements Action {
  readonly type = PrivateFinancingActionTypes.LoadPrivateFinancingsSuccess;
  constructor(public payload: { items: SummaryPrivateFinancingModel[]; total: number }) {}
}

export class LoadPrivateFinancingsFailure implements Action {
  readonly type = PrivateFinancingActionTypes.LoadPrivateFinancingsFailure;
  constructor(public payload: { error: any }) {}
}

/** Load by id */

export class LoadPrivateFinancing implements Action {
  readonly type = PrivateFinancingActionTypes.LoadPrivateFinancing;
  constructor(public payload: { uid: string }) {}
}

export class LoadPrivateFinancingSuccess implements Action {
  readonly type = PrivateFinancingActionTypes.LoadPrivateFinancingSuccess;
  constructor(public payload: SingleResponseModel<SummaryPrivateFinancingModel>) {}
}

export class LoadPrivateFinancingFailure implements Action {
  readonly type = PrivateFinancingActionTypes.LoadPrivateFinancingFailure;
  constructor(public payload: { error: any }) {}
}

/** Create */

export class CreatePrivateFinancing implements Action {
  readonly type = PrivateFinancingActionTypes.CreatePrivateFinancing;
  constructor(public payload: { privateFinancing: SummaryPrivateFinancingModel }) {}
}


export class CreatePrivateFinancingSuccess implements Action {
  readonly type = PrivateFinancingActionTypes.CreatePrivateFinancingSuccess;
  constructor(public payload: { privateFinancing: SummaryPrivateFinancingModel }) {}
}

export class CreatePrivateFinancingFailure implements Action {
  readonly type = PrivateFinancingActionTypes.CreatePrivateFinancingFailure;
  constructor(public payload: { error: any }) {}
}


/** Update */

export class UpdatePrivateFinancing implements Action {
  readonly type = PrivateFinancingActionTypes.UpdatePrivateFinancing;
  constructor(public payload: { privateFinancing: SummaryPrivateFinancingModel }) {}
}

export class UpdatePrivateFinancingSuccess implements Action {
  readonly type = PrivateFinancingActionTypes.UpdatePrivateFinancingSuccess;
  constructor(public payload: { privateFinancing: SummaryPrivateFinancingModel }) {}
}

export class UpdatePrivateFinancingFailure implements Action {
  readonly type = PrivateFinancingActionTypes.UpdatePrivateFinancingFailure;
  constructor(public payload: { error: any }) {}
}


/** Delete */

export class DeletePrivateFinancing implements Action {
  readonly type = PrivateFinancingActionTypes.DeletePrivateFinancing;
  constructor(public payload: { uid: string }) {}
}

export class DeletePrivateFinancingSuccess implements Action {
  readonly type = PrivateFinancingActionTypes.DeletePrivateFinancingSuccess;
  constructor(public payload: { uid: string }) {}
}

export class DeletePrivateFinancingFailure implements Action {
  readonly type = PrivateFinancingActionTypes.DeletePrivateFinancingFailure;
  constructor(public payload: { error: any }) {}
}

export type PrivateFinancingActions =
  | LoadPrivateFinancings
  | LoadPrivateFinancingsSuccess
  | LoadPrivateFinancingsFailure
  | LoadPrivateFinancing
  | LoadPrivateFinancingSuccess
  | LoadPrivateFinancingFailure
  | CreatePrivateFinancing
  | CreatePrivateFinancingSuccess
  | CreatePrivateFinancingFailure
  | UpdatePrivateFinancing
  | UpdatePrivateFinancingSuccess
  | UpdatePrivateFinancingFailure
  | DeletePrivateFinancing
  | DeletePrivateFinancingSuccess
  | DeletePrivateFinancingFailure
